export const NuritionalInformationHoney = [
    {
        title: 'Calories',
        weight: '60',
        value: ''
    }, {
        title: 'Total Fat',
        weight: '0g',
        value: '0%'
    }, {
        title: 'Saturated Fat',
        weight: '0g',
        value: '0%'
    }, {
        title: 'Trans Fat',
        weight: '0g',
        value: '-',
    }, {
        title: 'Sodium',
        weight: '0mg',
        value: '0%',
        isTopBorderHighLighted: true
    }, {
        title: 'Total Carbs',
        weight: '17g',
        value: '6%'
    }, {
        title: 'Total Sugars',
        weight: '17g',
        value: '',
        isNormal: true
    }, {
        title: '',
        weight: '',
        value: '34%<sup>&#8593;</sup>'
    }, {
        title: 'Protein',
        weight: '0g',
        value: '0%'
    }
]
export const ProductDataList: any = {
    'honey': {
        description: {
            h3: 'eco-friendly',
            h4: 'pure honey harvest',
            description: 'Immerse yourself in the purest essence of nature with our unfiltered ingredients: honey. We skip the ordinary, capturing raw, unadulterated honey that embodies the very soul of a bountiful honey harvest. It\'s nature\'s gift, untouched and eco-conscious. Taste the extraordinary in every jar and join us in preserving the essence of our planet.'
        },
        bottom_section: {
            image: '/assets/images/decorations/product_list/honey_jar_bulk_section.webp',
            title: 'bulk honey',
            secondary_title: 'wholesale',
            description: 'Discover the magic of unfiltered and raw honey with our wholesale gourmet market offerings. Elevate your culinary creations with the purest honey in bulk. Taste the excellence in every drop.',
            link: '/buy-in-bulk',
            link_title: 'buy now'
        }
    },
    'honey-packet': {
        description: {
            h3: 'single serve pack',
            h4: 'multi benefits honey',
            description: 'Elevate your day with our single-serve packs of honey, packed with the pure, unfiltered essence of raw honey. Discover the multi benefits of this golden elixir, conveniently portioned for on-the-go sweetness. From a natural energy boost to a sweet tea companion, our honey packets redefine the way you enjoy with one ingredient: honey.'
        },
        bottom_section: {
            image: '/assets/images/decorations/product_list/honey_packet_bulk_section.webp',
            title: 'bulk honey packets',
            secondary_title: 'wholesale',
            description: 'Uncover the enchantment of unfiltered, raw honey with our gourmet market\'s bulk honey packs. Elevate your creations with pure excellence in single-serve premium honey packets.',
            link: '/buy-in-bulk',
            link_title: 'buy now'
        }
    }
}
